import { render, staticRenderFns } from "./BasicConfiguration.vue?vue&type=template&id=352f9fe6&scoped=true&"
import script from "./BasicConfiguration.vue?vue&type=script&lang=js&"
export * from "./BasicConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./BasicConfiguration.vue?vue&type=style&index=0&id=352f9fe6&prod&lang=scss&scoped=true&"
import style1 from "./BasicConfiguration.vue?vue&type=style&index=1&id=352f9fe6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352f9fe6",
  null
  
)

export default component.exports